export default class formConfig {
  // 项目信息
  static projectInformation() {
    return [
      {
        title: "温馨提示",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "reminder",
            width: "100%",
          }
        ]
      },
      {
        title: "发包人及项目信息",
        name: "1",
        icon: "",
        tipsList: [
          { text: "填写说明：必须输入项如没有可填“无”，审核退回后如需修改发包人信息请点击右下角“修改发包人”按钮进行修改。" },
        ],
        formConfigList: [
          {
            label: "报建编号：",
            value: "constructionNo",
            type: "slot",
            slotName: "constructionNo",
            width: "100%",
            tip: "填写说明：建设单位（招标人）需进行项目登记后方可找到项目选择报建编号（报建类项目导入建委信息，非报建类项目自行录入）。",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            type: "select",
            label: "备案部门：",
            value: "regulators",
            width: "100%",
            placeholder: "请输入",
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201705121618210002",
            },
            rule: {
              required: true,
              message: "请输入备案部门",
              trigger: "blur"
            }
          },
          {
            label: "工程名称：",
            value: "prjName",
            type: "input",
            width: "100%",
            maxlength: 300,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            type: "select",
            label: "备案项目类别：",
            value: "tenderClassNum",
            width: "100%",
            tip: "施工类（即项目类别为“工程施工”，项目内容为“房屋建筑施工”或“市政工程施工”或“装饰装修施工”或“其他施工”或“设备安装施工”）项目负责人只允许一个项目在建；监理类（即项目类别为“工程服务”，项目内容为“监理”）项目负责人只允许三个项目同时在建。",
            clearable: true,
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510200918460003"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            type: "select",
            label: "备案项目内容：",
            value: "tenderContentNum",
            width: "100%",
            placeholder: "请输入",
            queryParams: {
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "建设单位：",
            value: "buildCorp",
            type: "input",
            width: "100%",
            disabled: true,
          },
          {
            label: "公司经济类型：",
            value: "economicType",
            width: "100%",
            type: "input",
            disabled: true,
          },
          {
            label: "建设用地取得方式：",
            value: "buildingLandObtained",
            width: "100%",
            type: "input",
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "建设单位法人代表：",
            value: "corpLegal",
            width: "100%",
            type: "input",
            maxlength: 100,
            disabled: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "建设单位法人授权委托人：",
            value: "linkMan",
            width: "50%",
            type: "input",
            maxlength: 20,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "授权委托人电话：",
            value: "linkTel",
            width: "50%",
            type: "input",
            maxlength: 20,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message: "输入的手机号码不正确！",
              },
            ],
          },
          {
            label: "项目批准机构：",
            value: "recordUnitName",
            width: "50%",
            type: "input",
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "工程地点：",
            value: "projectSite",
            width: "50%",
            type: "input",
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "批文名称：",
            value: "approvalName",
            width: "100%",
            type: "input",
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "立项批准文号：",
            value: "noteNumber",
            width: "50%",
            type: "input",
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "资金来源：",
            value: "fundsSources",
            width: "50%",
            type: "input",
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "资金性质：",
            value: "fundsCharacter",
            width: "50%",
            type: "input",
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "资金来源落实情况：",
            value: "situation",
            width: "50%",
            type: "input",
            maxlength: 300,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "房屋建筑工程建筑面积（ ㎡）：",
            value: "constructionArea",
            type: "slot",
            slotName: "constructionArea",
            width: "50%",
            maxlength: 14,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "结构层次：",
            value: "structuralHierarchy",
            width: "50%",
            type: "input",
            maxlength: 1000,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "市政工程规模：",
            value: "municipalProjectScale",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 1200,
            tip: "（最多可填1200个汉字）",
            disabled: false,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "其它工程规模：",
            value: "otherProjectScale",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 1200,
            tip: "（最多可填1200个汉字）",
            disabled: false,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
  // 施工单位信息
  static constructionUnitrmation() {
    return [
      {
        title: "施工单位信息",
        name: "1",
        icon: "",
        tipsList: [
          { text: "填写说明：必须输入项如没有可填“无”。" },
        ],
        formConfigList: [
          {
            label: "施工单位：",
            value: "constructionUnitName",
            type: "slot",
            slotName: "constructionUnitName",
            width: "100%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "施工单位确认时间：",
            value: "constructionSealDate",
            type: "input",
            width: "50%",
            disabled: true,
          },
          {
            label: "企业资质类别及等级：",
            value: "qualificationCategories",
            width: "50%",
            type: "input",
            maxlength: 1000,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "项目负责人：",
            value: "projectManagerName",
            type: "slot",
            slotName: "projectManagerName",
            width: "100%",
            maxlength: 20,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "执业资格类别等级及编号：",
            value: "qualificationCategoryLevel",
            width: "100%",
            type: "input",
            maxlength: 1000,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "项目负责人安全生产考核合格证书编号：",
            value: "managerCertificateNumber",
            width: "100%",
            type: "input",
            maxlength: 1000,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "专职安全生产管理人员姓名：",
            value: "managementCertificateName",
            width: "100%",
            type: "input",
            maxlength: 1000,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "专职安全生产管理人员安全生产考核合格证书编号：",
            value: "managementCertificateNumber",
            width: "100%",
            type: "input",
            maxlength: 1000,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "计划工期（日历天）：",
            value: "planTimeLimit",
            type: "slot",
            slotName: "planTimeLimit",
            width: "50%",
            maxlength: 10,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "工程造价（万元）：",
            value: "projectCost",
            type: "slot",
            slotName: "projectCost",
            width: "50%",
            maxlength: 30,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
  // 其他单位信息
  static constructionOtherUnitmation() {
    return [
      {
        title: "其他单位",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "勘察单位：",
            value: "econUnitName",
            type: "slot",
            slotName: "econUnitName",
            width: "100%",
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "勘察单位项目负责人：",
            value: "econProjectManagerName",
            type: "slot",
            slotName: "econProjectManagerName",
            width: "100%",
            maxlength: 20,
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "勘察工程造价（万元）：",
            value: "econProjectCost",
            type: "slot",
            slotName: "econProjectCost",
            width: "50%",
            maxlength: 30,
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "勘察单位确认时间：",
            value: "econSealDate",
            type: "input",
            width: "50%",
            disabled: true,
          },
          {
            label: "设计单位：",
            value: "designUnitName",
            type: "slot",
            slotName: "designUnitName",
            width: "100%",
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "设计单位项目负责人：",
            value: "designProjectManagerName",
            type: "slot",
            slotName: "designProjectManagerName",
            width: "100%",
            maxlength: 20,
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "设计工程造价（万元）：",
            value: "designProjectCost",
            type: "slot",
            slotName: "designProjectCost",
            width: "50%",
            maxlength: 30,
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "设计单位确认时间：",
            value: "designSealDate",
            type: "input",
            width: "50%",
            disabled: true,
          },
          {
            label: "监理单位：",
            value: "superUnitName",
            type: "slot",
            slotName: "superUnitName",
            width: "100%",
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "监理单位项目负责人：",
            value: "superProjectManagerName",
            type: "slot",
            slotName: "superProjectManagerName",
            width: "100%",
            maxlength: 20,
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "监理工程造价（万元）：",
            value: "superProjectCost",
            type: "slot",
            slotName: "superProjectCost",
            width: "50%",
            maxlength: 30,
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "监理单位确认时间：",
            value: "superSealDate",
            type: "input",
            width: "50%",
            disabled: true,
          },
        ]
      },
      {
        title: "联合体单位",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "是否联合体：",
            value: "isUnion",
            type: "select",
            clearable: true,
            disabled: false,
            optionData: [
              { name: "是", value: "1" },
              { name: "否", value: "0" }
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            }
          },
          {
            label: "联合体单位：",
            type: "slot",
            slotName: "unionCorpName",
            value: "unionCorpName",
            width: "100%;"
          },
          {
            label: "联合体单位类型：",
            type: "slot",
            slotName: "unionUnitType",
            value: "unionUnitType",
            width: "50%;"
          },
          {
            type: "slot",
            class: "formList",
            slotName: "unionList"
          }
        ]
      },
      {
        title: "联合体协议扫描件",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "扫描件：",
            type: "slot",
            slotName: "uploadUnionFile"
          }
        ]
      }
    ]
  }
  // 其他信息
  static otherInformation() {
    return [
      {
        title: "发包范围",
        name: "1",
        icon: "",
        tipsList: [
          { text: "填写说明：必须输入项如没有可填“无”。" },
        ],
        formConfigList: [
          {
            label: "发包范围：",
            value: "contractScope",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 1200,
            tip: "（最多可填1200个汉字）",
            disabled: false,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "工程施工单位项目管理机构配备情况",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "工程施工单位项目管理机构配备情况：",
            type: "slot",
            slotName: "organizationAllocationinfoList",
          },
        ]
      },
      {
        title: "备注",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "备注：",
            value: "remarks",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 1200,
            tip: "（最多可填1200个汉字）",
            disabled: false,
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "审核意见",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "历史审核记录：",
            type: "slot",
            class: "list",
            slotName: "auditBtn",
          },
        ]
      },
      {
        title: "直接发包备案记录",
        name: "5",
        icon: "",
        formConfigList: [
          {
            label: "直接发包备案记录：",
            type: "slot",
            class: "list",
            slotName: "recordDirectlyLog",
          },
        ]
      },
    ];
  }
}
